import { toUpperCase } from './helpers/string';
import { PRIVACY_SETTINGS_SCHEMA_TO_API_MAP } from './manage-user-privacy-settings';
const getAllowedPrivacySettingsFor = (data, schemaValue) => {
  const apiResponseKey = PRIVACY_SETTINGS_SCHEMA_TO_API_MAP[schemaValue];
  const allowedPrivacySettings = data[apiResponseKey];
  if (!allowedPrivacySettings || !allowedPrivacySettings.length) {
    return null;
  }
  return allowedPrivacySettings.map(toUpperCase);
};
export const transformUserManagePrivacySettingsAllowed = data => Object.keys(PRIVACY_SETTINGS_SCHEMA_TO_API_MAP).reduce((memo, schemaValue) => {
  memo[schemaValue] = getAllowedPrivacySettingsFor(data, schemaValue);
  return memo;
}, {});